import React, { useEffect, useState } from 'react';
import '../../Static/priceinfo.css';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';


const KajeView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);

    // console.log(formData)







    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper style={{ padding: '2vh' }}>
                        <div style={{ margin: '1% 0%', width: '100%' }}>

                            <h3 className='centered-heading'>kaje View</h3>
                            <div className="dashed-line"></div>

                            <table>
                                <thead>
                                    <th>Size</th>
                                    <th>Stitch Qty</th>
                                    <th>Issue Qty</th>
                                    <th>Bal Qty</th>
                                </thead>
                                <tbody>
                                    {formData?.tableData?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.size}</td>
                                            <td>{item.rqty}</td>
                                            <td>{item.kissqty}</td>
                                            <td>{item.kbalqty}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                        </div>
                    </Paper>

                </Grid>

            </Grid>

        </>
    );
};

export default KajeView;
